import { Trans, useTranslation } from 'react-i18next';
import styles from './Error.module.css';
import React from 'react';
import { useErrorController } from './Error.controller.ts';

export default function ErrorView() {
  const { t } = useTranslation();
  const { tryAgain } = useErrorController();

  return (
    <div className={styles.main}>
      <div className={styles.container}>
        <img className={styles.logo} src="/images/logo.png" alt={t('ui.altLogo')} />

        <h1>{t('error.errorPageHeading')}</h1>

        <p className={styles.text}>
          <Trans i18nKey="error.errorPageContent" components={{ br: <br /> }} />
        </p>

        <button className={styles.button} onClick={tryAgain}>
          {t('ui.tryAgain')}
        </button>
      </div>
    </div>
  );
}
